import { UserQueueSettings } from '../../interfaces/user-queue-settings';
import { LimitOffsetPaging, Sort } from '../paged-results/limit-offset-paging.model';

export class FaxFilters {
  selectedClientIds = [];
  selectedStatuses = [];
  selectedAssignedToIds = [];
  assignedClientLeadIds = [];
  includeArchived = false;
  excludeDirectUserAssignmentWorkflowClients = true;
}

export class FaxListSettings {
  filters: FaxFilters = new FaxFilters();
  paging: LimitOffsetPaging = LimitOffsetPaging.empty;
}

export class FaxQueueSettings extends FaxListSettings implements UserQueueSettings {
  position: number;
  sort: Sort = new Sort('received_at', 'desc');
}
